import {useForm} from "@mantine/form";
import {
    FormShipperInformationFormValues,
    formShipperInformationInitialValues
} from "./Form.shipper.information.types";
import {Button, Divider, Grid, Group, Select, Stack, TextInput, Title} from "@mantine/core";
import MantineForm from "../../../common/Mantine.form";
import {ArrowRight} from "tabler-icons-react";
import React from "react";
import {IUser} from "../../../../api/User/User.types";

interface Props {
    onSubmit?: (values: any) => void
    buttons?: any,
    initialValues?: any,
    user:IUser,
}

function ShipperInformation({onSubmit, buttons, initialValues, user}: Props) {
    const form = useForm({
        initialValues: initialValues || formShipperInformationInitialValues
    });

    function handleSubmit(values: any) {
        if (onSubmit) {
            onSubmit(values)
        }
    }

    function renderButtons() {
        if (buttons) {
            return buttons;
        } else {
            return (
                <Group position="right" mt="xl" align="flex-end">
                    <Button color="blue" type="submit" rightIcon={<ArrowRight/>}>
                        Next
                    </Button>
                </Group>
            )
        }
    }

    if (!user?.shippers) {
        return <div>No shippers found</div>
    }

    function onShipperChange(shipperId: any) {
        let selectedShipper = user!.shippers!.find(sh => sh.entityID === shipperId);

        form.getInputProps(FormShipperInformationFormValues.shipperId).onChange(shipperId);

        if (selectedShipper){
            form.setFieldValue(FormShipperInformationFormValues.shipperEmail, selectedShipper.email);
            form.setFieldValue(FormShipperInformationFormValues.shipperPhone, selectedShipper.phone);
            form.setFieldValue(FormShipperInformationFormValues.shipperFax, selectedShipper.fax);
            form.setFieldValue(FormShipperInformationFormValues.shipperId, selectedShipper.entityID);
            form.setFieldValue(FormShipperInformationFormValues.shipperName, selectedShipper.entityName);

            Object.keys(selectedShipper.address).forEach(field =>{
                form.setFieldValue(field, selectedShipper!.address[field]);
            })
        }
    }

    return (
        <form onSubmit={form.onSubmit(handleSubmit)}>
            <Stack>
                <Title order={3}>Shipper Information</Title>
                <Divider/>
                <Grid>
                    <Grid.Col md={12}>
                        <Select
                            data={user?.shippers?.map(sh => ({value: sh.entityID, label: sh.entityName}))}
                            required
                            placeholder="Shipper Name"
                            label="Name"
                            {...form.getInputProps(FormShipperInformationFormValues.shipperId)}
                            onChange={onShipperChange}
                        />
                    </Grid.Col>
                    {form.values[FormShipperInformationFormValues.shipperId] &&
                        <>
                            <Grid.Col md={12}>
                                <TextInput
                                    required
                                    disabled
                                    placeholder="Shipper Email"
                                    label="Email"
                                    {...form.getInputProps(FormShipperInformationFormValues.shipperEmail)}
                                />
                            </Grid.Col>
                            <Grid.Col md={12}>
                                <TextInput
                                    required
                                    disabled
                                    placeholder="Shipper Phone"
                                    label="Phone"
                                    {...form.getInputProps(FormShipperInformationFormValues.shipperPhone)}
                                />
                            </Grid.Col>
                            <Grid.Col md={12}>
                                <TextInput
                                    required
                                    disabled
                                    placeholder="Shipper Fax"
                                    label="Fax"
                                    {...form.getInputProps(FormShipperInformationFormValues.shipperFax)}
                                />
                            </Grid.Col>
                            <Grid.Col span={12}>
                                <MantineForm.Address form={form} disableAllFields/>
                            </Grid.Col>
                        </>
                    }
                </Grid>
                {renderButtons()}
            </Stack>
        </form>
    )

}

export default ShipperInformation;